<template>
  <Card>
    <el-row :gutter="20" class="action_card">
      <el-col :lg="4" :xs="6" class="action_card_image">
        <div class="crop"><img src="@/assets/images/no_account.png" alt /></div>
      </el-col>
      <el-col :lg="16" :xs="14">
        <div class="pending_content pending_content_center">
          <span
            >{{ $t('notification.pendingIdentityProof.header') }}
            <el-popover popper-class="pop_content" placement="bottom" width="200" trigger="click">
              <p class="whitespace-pre-line">
                <i18n path="notification.pendingIdentityProof.content" tag="p">
                  <template v-slot:doc>{{ doc }}</template>
                  <template v-slot:doc2>{{ doc2 }}</template>
                </i18n>
              </p>
              <i slot="reference" class="el-icon-info info_icon_mobile"></i>
            </el-popover>
          </span>
          <p class="whitespace-pre-line">
            <i18n path="notification.pendingIdentityProof.content" tag="p">
              <template v-slot:doc>{{ doc }}</template>
              <template v-slot:doc2>{{ doc2 }}</template>
            </i18n>
          </p>
        </div>
      </el-col>
      <el-col :lg="4" :xs="4" class="action_card_button">
        <div class="form_button right_content">
          <router-link :to="{ name: 'depositFunds' }" class="el-button blue_button" data-testid="depositFunds">
            {{ $t('register.btn.fundnow') }}
          </router-link>
        </div>
        <router-link :to="{ name: 'depositFunds' }" class="" data-testid="depositFunds">
          <i class="el-icon-arrow-right right_content_mobile"></i>
        </router-link>
      </el-col>
    </el-row>
  </Card>
</template>

<script>
import Card from '@/components/Card';

export default {
  name: 'notification',
  components: { Card },
  props: { id: Boolean, poa: Boolean },
  data() {
    return {
      doc2: ''
    };
  },
  computed: {
    doc() {
      let doc;
      if (this.id && this.poa) {
        this.doc2 = this.$t('notification.pendingIdentityProof.both');
        doc = this.$t('notification.pendingIdentityProof.both');
      } else if (this.id) {
        this.doc2 = this.$t('notification.pendingIdentityProof.single');
        doc = this.$t('notification.pendingIdentityProof.id');
      } else if (this.poa) {
        this.doc2 = this.$t('notification.pendingIdentityProof.single');
        doc = this.$t('notification.pendingIdentityProof.poa');
      }

      return doc;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/home/pendingAction.scss';
</style>
